var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5H32V27H0V5Z",
    fill: "#2A2FAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 8.5L16.3366 9.5365H17.4264L16.5448 10.1771L16.8815 11.2135L15.9998 10.5729L15.1181 11.2135L15.4549 10.1771L14.5732 9.5365H15.6631L15.9998 8.5Z",
    fill: "#FFE70E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 20.5L16.3366 21.5365H17.4264L16.5448 22.1771L16.8815 23.2135L15.9998 22.5729L15.1181 23.2135L15.4549 22.1771L14.5732 21.5365H15.6631L15.9998 20.5Z",
    fill: "#FFE70E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 18.5L12.3366 19.5365H13.4264L12.5448 20.1771L12.8815 21.2135L11.9998 20.5729L11.1181 21.2135L11.4549 20.1771L10.5732 19.5365H11.6631L11.9998 18.5Z",
    fill: "#FFE70E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.5L12.3366 11.5365H13.4264L12.5448 12.1771L12.8815 13.2135L11.9998 12.5729L11.1181 13.2135L11.4549 12.1771L10.5732 11.5365H11.6631L11.9998 10.5Z",
    fill: "#FFE70E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 18.5L20.3366 19.5365H21.4264L20.5448 20.1771L20.8815 21.2135L19.9998 20.5729L19.1181 21.2135L19.4549 20.1771L18.5732 19.5365H19.6631L19.9998 18.5Z",
    fill: "#FFE70E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 10.5L20.3366 11.5365H21.4264L20.5448 12.1771L20.8815 13.2135L19.9998 12.5729L19.1181 13.2135L19.4549 12.1771L18.5732 11.5365H19.6631L19.9998 10.5Z",
    fill: "#FFE70E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49981 14.5L9.83663 15.5365H10.9264L10.0448 16.1771L10.3815 17.2135L9.49981 16.5729L8.61812 17.2135L8.95494 16.1771L8.07325 15.5365H9.16306L9.49981 14.5Z",
    fill: "#FFE70E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4998 14.5L22.8366 15.5365H23.9264L23.0448 16.1771L23.3815 17.2135L22.4998 16.5729L21.6181 17.2135L21.9549 16.1771L21.0732 15.5365H22.1631L22.4998 14.5Z",
    fill: "#FFE70E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.077077fd.svg";
export { ForwardRef as ReactComponent };